import React from "react";
import { Tabs, Tab, Box, Typography, Card } from "@mui/material";
import { FaShieldAlt } from "react-icons/fa";
import JavaQuiz from "../Java/JavaQuiz";

const sections = [
    "Java Quiz",
    "JavaScript Quiz",
    "C++ Quiz",
    "Python Quiz",
    "TypeScript Quiz",
    "Express Quiz",
    "SpringBoot Quiz",
];

function Quizzes() {
    const [activeTab, setActiveTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const tabContent = [
        <Typography>
            <div
                style={{fontWeight:"700", backgroundColor:"goldenrod",
                    padding:"8px",borderRadius:"5px",
                    width:"fit-content", }}>Java Quiz
            </div>
            <JavaQuiz/>
       </Typography>,

        <Typography>
            <div style={{fontWeight: "700"}}>Course Overview</div>
            Learners gain practical insights through scenario-based training, conflict management modules, legal
            understanding, and physical intervention workshops. The course is aligned with SIA license standards.
        </Typography>,
        <Typography>
            <div style={{fontWeight: "700"}}>Qualification</div>
            Graduates receive a Level 2 Award in Working as a Door Supervisor in the Private Security Industry or
            equivalent. This qualification is mandatory for SIA license application.
        </Typography>,
        <Typography>
            <div style={{fontWeight: "700"}}>Description</div>
            Modules include public safety responsibilities, physical intervention, emergency procedures, reporting
            duties, and legal obligations. It spans approximately 5 days with both written and practical assessments.
        </Typography>,
        <Typography>
            <div style={{fontWeight: "700"}}>Suitable For</div>
            Perfect for individuals interested in protective services across entertainment, corporate, retail,
            transportation, and public sectors — especially for front-line security roles.
        </Typography>,
        <Typography>
            <div style={{fontWeight: "700"}}>Career Path</div>
            Possible careers: Security Guard, Event Steward, Close Protection Officer, Surveillance Agent, Retail
            Security, and Control Room Operator. Further training enables progression to supervisory and managerial
            positions.
        </Typography>,
        <Typography>
            <div style={{fontWeight: "700"}}>Review</div>
            Learners praise its realism, confidence-building exercises, and readiness for live security work. Reviews
            highlight knowledgeable instructors and clear licensing preparation.
        </Typography>
    ];

    return (
        <Box
            sx={{
                padding: "0.5rem",
                width: "100%",
                margin: "auto",
                height:"100%",
                borderRadius: "12px",
                fontFamily: "Segoe UI",
            }}
        >
            <Card sx={{ padding: "0.5rem",  boxShadow: 4,borderTop:"4px solid goldenrod ", borderRadius: "12px" }}>
                <Typography variant="h6" style={{ fontWeight: "400", textAlign:"center", color: "#09122C" }}>
                    Trainees' Quiz Page
                </Typography>
                <br/>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="SIA Course Tabs"
                    sx={{
                        "& .MuiTab-root": {
                            fontWeight: "bold",
                            fontSize: "1rem",
                            width: "fit-content",
                            transition: "all 0.3s ease",
                            textTransform: "none",
                            color: "#09122C",
                        },
                        "& .MuiTab-root:hover": {
                            backgroundColor: "#09122C",
                            color: "goldenrod",
                            borderRadius: "8px 8px 0 0",
                        },
                    }}
                >
                    {sections.map((label, index) => (
                        <Tab key={index} label={label}  />
                    ))}
                </Tabs>
                <br/>
                <Box sx={{ padding: "1.5rem", fontSize: "1.05rem",backgroundColor:"#09122C",borderRadius:"5px", lineHeight: "1.75", color: "white" }}>
                    {tabContent[activeTab]}
                </Box>
            </Card>
        </Box>
    );
}
export default Quizzes;
